import { useDispatch } from 'react-redux';
import { CircularProgress, Divider, Stack, Typography } from '@mui/material';
import { Close } from 'pages/home/ui/Icons';
import { COLOR_ACCENT, COLOR_LIGHT_GRAY_ALPHA_2, COLOR_LIGHT_GRAY_INPUT } from 'shared/config';
import { BORDER_RADIUS_XXL } from 'shared/config/theme/common';

import { modalActions, ModalType } from '../model';

export interface ILoadingPayload {
  type: ModalType.Loading;
  data: { title: string; text?: string };
}

export const LoadingModal = ({ data: { title, text } }: { data: ILoadingPayload['data'] }) => {
  const dispatch = useDispatch();
  return (
    <Stack
      spacing={5}
      sx={{
        paddingTop: { xs: 0, sm: 0 },
        paddingBottom: text ? 4 : 8,
        maxWidth: { xs: 328, sm: 654 },
        backgroundColor: 'rgb(25, 24, 54)',
        width: '100%',
        borderRadius: BORDER_RADIUS_XXL,
        position: 'relative',
      }}
    >
      <Close
        sx={{ color: COLOR_LIGHT_GRAY_INPUT, cursor: 'pointer', position: 'absolute', right: '16px', top: '16px', width: '20px', height: '20px' }}
        onClick={() => dispatch(modalActions.closeModal())}
      />
      <Divider sx={{ background: COLOR_LIGHT_GRAY_ALPHA_2, marginTop: '48px!important'}} />
      <Stack alignItems="center" spacing={3} px={3}>
          <Typography variant="h4" className="center" sx={{ px: 2, mt: '30px!important'}}>
              {title}
          </Typography>
        {text && <Typography variant="subtitle1" sx={{textAlign: 'center', marginBottom: '20px!important'}}>{text}</Typography>}
      </Stack>
    </Stack>
  );
};
